module.exports = __webpack_public_path__ + "img/384.31fd08a2.png";